// Shows or hides the credit-card section (#payment-section) based on the live
// order total. The card is always rendered server-side so the Clover SDK can
// mount its hosted-field iframes, but a promo-free ticket needs no card while a
// donation add-on brings the card back -- and that total changes client-side.
//
// Pages drive it by calling window.updatePaymentVisibility(total) whenever their
// total changes (see the donate and checkout forms). The initial state comes
// from #payment-section[data-order-total] (the render-time cart total).
//
// Hiding sets display:none. Doing that to a Clover field container *before* the
// SDK mounts can leave the hosted-field iframes zero-sized, so the first hide is
// deferred until Clover signals it has mounted (the `clover:mounted` event).
(function () {
  function section() {
    return document.getElementById('payment-section');
  }

  function apply(total) {
    var el = section();
    if (!el) return;
    var amount = parseFloat(total);
    el.hidden = !(amount > 0);
  }

  // Exposed so page scripts can push the live total as the donor edits it.
  window.updatePaymentVisibility = apply;

  function initialTotal() {
    var el = section();
    if (!el) return 0;
    return parseFloat(el.dataset.orderTotal || '0') || 0;
  }

  function init() {
    apply(initialTotal());
  }

  document.addEventListener('DOMContentLoaded', function () {
    // No Clover on the page: safe to set the state right away.
    if (!document.querySelector('[data-pakms-key]')) {
      init();
      return;
    }

    // Clover present: don't hide before its iframes mount (hiding a container
    // with display:none before mount can leave the hosted fields zero-sized).
    // clover-payment.js may have mounted already (its DOMContentLoaded handler
    // can run before this one), so check the flag before waiting on the event.
    if (window.cloverFieldsMounted) {
      init();
      return;
    }

    var done = false;
    document.addEventListener('clover:mounted', function () {
      done = true;
      init();
    }, { once: true });
    // Fallback: if the SDK never signals (blocked/offline), still set state.
    setTimeout(function () {
      if (!done) init();
    }, 3000);
  });
})();
